export const locale = {
    lang: "pt-BR",
    data: {
        REGISTER_IDENTITY: {
            TITLE: "Seja bem-vindo!",
            SUBTITLE: "preencha os campos a seguir para iniciar sua jornada até se tornar um Guru!",

            CREATE: "Salvar",
            CANCEL: "Cancelar",

            REQUIRED: "Este campo é obrigatório.",
            NAME: "Nome",
            SURNAME: "Sobrenome",

            USERNAME: {
                REQUIRED: "E-mail é obrigatório.",
                INVALID: "Necessário preencher um email válido."
            },

            USERNAME_ALREADY_IN_USER:
                "Email já cadastrado em nossa plataforma. Caso não lembre sua senha utilize o 'Esqueceu a senha?'",
            GENERIC_ERROR: "Erro ao criar usuário. Tente novamente mais tarde ou entre em contato com nosso suporte"
        }
    }
};
